'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ClaimDetailsDescription = require('../components/ClaimDetailsDescription.js');
var EvaluationItem = require('../components/EvaluationItem.js');
var ClaimStatusChip = require('../../../components/ClaimStatusChip/ClaimStatusChip.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Evaluations = _ref => {
  let {
    claim
  } = _ref;
  const {
    claimsClaimDetailsLabelIntelligence,
    claimsClaimDetailsLabelRulesMatched
  } = nthHookTranslations.useTranslations();
  const {
    policyRulesMatched,
    irisRecommendations,
    irisStatus,
    status
  } = claim;
  const policyRulesEvaluations = policyRulesMatched ? /*#__PURE__*/React__default["default"].createElement("div", null, policyRulesMatched.map((match, i) => /*#__PURE__*/React__default["default"].createElement(EvaluationItem["default"], {
    key: i,
    action: match.action,
    message: match.agentMessage
  }))) : null;
  const intelligenceEvaluations = irisRecommendations ? /*#__PURE__*/React__default["default"].createElement("div", null, irisRecommendations.map((match, i) => /*#__PURE__*/React__default["default"].createElement(EvaluationItem["default"], {
    key: i,
    action: match.action,
    message: match.message
  }))) : null;
  const policyPending = status === 'Created';
  const irisPending = irisStatus === 'Pending';
  const policyValueDisplay = policyPending ? /*#__PURE__*/React__default["default"].createElement(ClaimStatusChip["default"], {
    status: "Pending"
  }) : policyRulesEvaluations;
  const irisValueDisplay = irisPending ? /*#__PURE__*/React__default["default"].createElement(ClaimStatusChip["default"], {
    status: "Pending"
  }) : intelligenceEvaluations;
  return /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionList, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionContainer, null, policyValueDisplay && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsLabelRulesMatched,
    value: policyValueDisplay
  }), irisValueDisplay && /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescription, {
    label: claimsClaimDetailsLabelIntelligence,
    value: irisValueDisplay
  })));
};
var Evaluations$1 = nthHookTranslations.withTranslationsProvider(Evaluations, {
  translationKeys: ['claimsClaimDetailsLabelIntelligence', 'claimsClaimDetailsLabelRulesMatched']
});

exports["default"] = Evaluations$1;
